<template>
  <c-modal
    class="c-blogKindSelect"
    title="ブログ投稿を始める"
    :width="782"
    :active="isVisible"
    :can-cancel="false"
    @close="$emit('close')"
  >
    <div class="c-blogKindSelect_body">
      <div class="c-blogKindSelect_title">ブログの種類を選びましょう</div>
      <div class="c-blogKindSelect_kind">
        <div
          class="c-blogKindSelect_kindContent"
          :class="{ 'c-blogKindSelect_kindContent-active': kind === KIND.NORMAL }"
          @click="updateBlogKind(KIND.NORMAL)"
        >
          <div class="c-blogKindSelect_kindIcon">
            <coconala-icon
              name="file-alt-regular"
              size="24px"
            />
          </div>
          <c-radio
            size="is-small"
            v-model="kind"
            :native-value="KIND.NORMAL"
          >
            <div class="c-blogKindSelect_kindTitle">記事</div>
          </c-radio>
          <div class="c-blogKindSelect_kindDescription">
            コラム、ノウハウ、日記などテキストメインの各種情報発信
          </div>
        </div>
        <div
          class="c-blogKindSelect_kindContent c-blogKindSelect_kindContent-right"
          :class="{ 'c-blogKindSelect_kindContent-active': kind === KIND.CONTENTS }"
          @click="updateBlogKind(KIND.CONTENTS)"
        >
          <div class="c-blogKindSelect_kindIcon">
            <coconala-icon
              name="photo-video-solid"
              size="24px"
            />
          </div>
          <c-radio
            size="is-small"
            v-model="kind"
            :native-value="KIND.CONTENTS"
          >
            <div class="c-blogKindSelect_kindTitle">コンテンツ</div>
          </c-radio>
          <div class="c-blogKindSelect_kindDescription">
            音声、動画、イラストなどコンテンツがメインの発信
          </div>
        </div>
        <div
          class="c-blogKindSelect_kindContent c-blogKindSelect_kindContent-right"
          :class="{ 'c-blogKindSelect_kindContent-active': kind === KIND.ANNOUNCE }"
          @click="updateBlogKind(KIND.ANNOUNCE)"
        >
          <div class="c-blogKindSelect_kindIcon">
            <coconala-icon
              name="info-circle"
              size="24px"
            />
          </div>
          <c-radio
            size="is-small"
            v-model="kind"
            :native-value="KIND.ANNOUNCE"
          >
            <div class="c-blogKindSelect_kindTitle">ココナラに関する告知</div>
          </c-radio>
          <div class="c-blogKindSelect_kindDescription">
            新サービス、キャンペーン、自身のスケジュールなど
            <p v-if="isPaid">(有料販売はできません)</p>
          </div>
        </div>
      </div>
    </div>
    <div class="c-blogKindSelect_notice">
      <div>
        <coconala-icon
          name="exclamation-circle"
          size="12px"
        />
      </div>
      投稿内容が「告知」であるにも関わらず、他の種類が選択さ<br>
      れた場合は運営にて削除・変更を行わせていただきます。
    </div>
    <div slot="footer">
      <div class="c-blogKindSelect_action">
        <c-button
          class="c-blogKindSelect_cancel"
          @click="$emit('close')"
        >キャンセル</c-button>
        <c-button
          color="primary"
          @click="$emit('startEdit')"
        >入力へ進む</c-button>
      </div>
    </div>
  </c-modal>
</template>
<script>
// vuex
import { mapState } from 'vuex'

export default {
  name: 'BlogKindSelectModal',
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    blogKind: {
      type: Number,
      required: true
    },
    isPaid: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      kind: this.blogKind
    }
  },
  computed: {
    ...mapState('pages/blogs/constants', ['KIND'])
  },
  methods: {
    updateBlogKind(kind) {
      this.kind = kind
      this.$emit('update:blogKind', kind)
    }
  }
}
</script>

<style lang="scss" scoped>
.c-blogKindSelect {
  &_body {
    margin: 0 auto;
    padding: 0 24px;
    width: 100%;
  }
  &_title {
    font-weight: bold;
  }
  &_kind {
    display: flex;
    margin-top: 16px;
  }
  &_kindContent {
    cursor: pointer;
    text-align: center;
    width: 223px;
    height: 196px;
    border: 1px solid $color-gray-200;
    border-radius: 4px;
    background-color: $color-gray-50;
    &-right {
      margin-left: 16px;
    }

    &-active {
      border: 1px solid $color-blue-500;
      background-color: $color-white;
    }
  }
  &_kindTitle {
    font-size: 14px;
  }
  &_kindDescription {
    margin: 16px;
    font-size: 12px;
    text-align: left;
  }
  &_kindIcon {
    margin: 32px 0 20px;
    color: $color-gray-700;
  }
  &_notice {
    display: flex;
    justify-content: center;
    margin-top: 16px;
    font-size: 12px;
    color: $color-red-500;
    i {
      margin-right: 8px;
    }
  }
  &_action {
    text-align: center;

    button {
      width: 128px;
    }
  }
  &_cancel {
    margin-right: 12px;
  }
  /deep/ .c-modal_footer {
    padding: 40px 0;
  }
}
</style>
